import { useMutation } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { queryClient } from 'src/components/queryProvider';
import { PublicationTypes } from 'src/interfaces/Publication';
import { lang, queryKeys, requestCCApi } from 'src/utils';

export const useUpdatePublication = () => {
  return useMutation({
    mutationFn: fetchUpdatePublication,
    onSuccess: async () => {
      queryClient.invalidateQueries(
        queryKeys.enrichedLocations.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequestNamesByAssemblyIds.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequests.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.productPublications.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.locationListing.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.useViewLocationsByGroupsWithoutPaginationFilterByLocationCode.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.viewLocations.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.getLocationGroupsWithLocationCount.invalidateAll(),
      );
    },
  });
};

const fetchUpdatePublication = (
  params: {
    locationCodes?: string[];
    locationGroupIDs?: number[];
    publicationType?: PublicationTypes;
    assemblyIds?: number[];
  } | void,
) => {
  const { locationCodes, locationGroupIDs, publicationType, assemblyIds } =
    params || {};

  const data = {
    ...(isEmpty(locationCodes) && isEmpty(locationGroupIDs) && { all: true }),
    ...(!isEmpty(locationCodes) && { location_code: locationCodes }),
    ...(!isEmpty(locationGroupIDs) && { location_group_id: locationGroupIDs }),
    ...(!isEmpty(publicationType) && { publication_type: publicationType }),
    ...(!isEmpty(assemblyIds) && { assembly_ids: assemblyIds }),
  };

  return requestCCApi(
    {
      url: '/publish',
      method: 'POST',
      data: data,
    },
    true,
    lang.publishFailed,
  );
};
